import React from 'react'
import SecondaryButton from 'src/comps/Atom/Buttons/SecondaryButton'

import IconPrinter from 'client/icons/Printer'
import { useS4LContext } from '@s4l/react-context'

const PrintButton = ({ children }: { children: React.ReactNode }) => {
  const { mobileAppVersion } = useS4LContext()

  if (mobileAppVersion) return null

  return (
    <SecondaryButton
      type="button"
      size="m"
      leftIcon={<IconPrinter />}
      onClick={event => {
        event.preventDefault()
        window.print()
      }}
    >
      {children}
    </SecondaryButton>
  )
}

export default PrintButton
